var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M8 0.625C4.11719 0.625 1 3.19531 1 6.3125C1 7.625 1.51953 8.82812 2.42188 9.78516C2.03906 10.8516 1.19141 11.7812 1.16406 11.7812C0.972656 11.9727 0.945312 12.2461 1.02734 12.4922C1.13672 12.7383 1.38281 12.875 1.65625 12.875C3.32422 12.875 4.66406 12.1914 5.45703 11.6172C6.25 11.8633 7.09766 12 8 12C11.8555 12 15 9.45703 15 6.3125C15 3.19531 11.8555 0.625 8 0.625ZM8 10.6875C7.26172 10.6875 6.52344 10.5781 5.83984 10.3594L5.21094 10.168L4.69141 10.5508C4.30859 10.8242 3.76172 11.125 3.10547 11.3438C3.32422 11.0156 3.51562 10.6328 3.65234 10.25L3.95312 9.48438L3.37891 8.88281C2.88672 8.36328 2.3125 7.48828 2.3125 6.3125C2.3125 3.90625 4.85547 1.9375 8 1.9375C11.1172 1.9375 13.6875 3.90625 13.6875 6.3125C13.6875 8.74609 11.1172 10.6875 8 10.6875Z",
    fill: "#4A494E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIcon);
export default __webpack_public_path__ + "static/media/requestIcon.e6592006a39b0ab7fd04ecb4944c8d4b.svg";
export { ForwardRef as ReactComponent };